import React, { useState } from "react";
import "../css/ModalPopUp.css";
import MasjidKafPwkSlider from "./slider/MasjidKafPwkSlider";
import Footer from "../../../../../../Footer";

export default function MasjidKafPwk() {

  return (
    <div className="modal-img">
        <MasjidKafPwkSlider/>
        <Footer/>
    </div>
  );
}